import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { deleteImageFromSlider } from 'redux/image-sliders/actions';

import CommonSwapIcon from 'components/common/link-elements/CommonSwapIcon';
import CommonSliderImageDetails
  from 'components/dashboard/image-slider/common-slider/CommonSliderImageDetails';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import './CommonSliderImagesListItem.css';


function CommonSliderImagesListItem(props) {
  const { image, deleteImageFromSlider } = props;
  const [showOptions, setShowOptions] = useState(false);
  const { t } = useTranslation();

  const calculateInfoText = image => {
    if ((!image.title || !image.description) && !showOptions) {
      return <div className="customize-text">{t('Customize Image Link')}</div>;
    }

    if (showOptions) {
      return <div className="customize-text">{t('Change Image')}</div>;
    }

    if ((image.title || image.description) || !showOptions) {
      return (
        <>
          <div className="title">{image.title}</div>
          <div className="description">{image.description}</div>
        </>
      );
    }
  };

  return (
    <div className="common-slider-images-list-item__component">
      <div
        className="header-content"
        onClick={() => setShowOptions(!showOptions)}
        role="button"
        tabIndex={-1}
      >
        {/*<CommonSwapIcon />*/}
        <div
          className="image-wrapper"
          style={{ backgroundImage: image.image && `url(${image.image})` }}
        />
        <div className="info-wrapper">
          {calculateInfoText(image)}
        </div>
        <div className={`arrow${showOptions ? ' up' : ' right'}`} />
      </div>

      {showOptions &&
        <div className="options-content">
          <CommonSliderImageDetails item={image} />
          <div className="delete">
            <CommonLinkDeleteButton
              image
              linkItem={image}
              deleteFunction={deleteImageFromSlider}
            />
          </div>
        </div>
      }
    </div>
  );
}

CommonSliderImagesListItem.propTypes = {
  deleteImageFromSlider: PropTypes.func.isRequired,
  image: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    deleteImageFromSlider,
  },
)(CommonSliderImagesListItem);
